// Angular import
import { Component, Input, OnDestroy, Inject, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { SpinnerService } from '../../../../core/services/spinner.service';

// project import
import { Spinkit } from './spinkits';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss', './spinkit-css/sk-line-material.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
  // public props
  isSpinnerVisible = true;
  Spinkit = Spinkit;
  @Input() backgroundColor = "#673ab7";
  @Input() spinner = Spinkit.skLine;

  // Constructor
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private spinnerService: SpinnerService
  ) {
    // Suscribirse a los cambios del servicio
    this.spinnerService.spinner$.subscribe(
      (show) => {
        this.isSpinnerVisible = show;
        this.spinner = show ? Spinkit.skThreeBounce : Spinkit.skLine;
      }
    );

    // Mantener la funcionalidad de navegación
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.isSpinnerVisible = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.isSpinnerVisible = false;
        }
      },
      () => {
        this.isSpinnerVisible = false;
      }
    );
  }

  // life cycle event
  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
